import { z } from 'zod';

import { errorMessage } from '../config';

export type LoginSchema = z.infer<typeof loginData>;
export type LoginErrors = z.inferFlattenedErrors<
	typeof loginData
>['fieldErrors'];

export const loginData = z.object({
	login: z.string().min(3, errorMessage.login_too_short),
	password: z.string().min(8, errorMessage.password_too_short),
});
